import { mapboxToken } from "../../configuration";

export default async function getAddressfromLatLong(latitude, longitude){
    try {
        const mapboxResponse = await fetch(`https://api.mapbox.com/search/geocode/v6/reverse?longitude=${longitude}&latitude=${latitude}&access_token=${mapboxToken}`);

        if(!mapboxResponse.ok) throw new Error("Something went wrong with map API");

        const resp = await mapboxResponse.json();
        if(Object.hasOwn(resp, "features") && Array.isArray(resp.features) && resp.features.length > 0){
            return resp?.features[0]?.properties?.full_address
        }
        return "N/A";
    } catch (error) {
        console.log("getAddressfromLatLong error ", error)
    }
}